import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranscriptionPlaybackComponent } from './components/transcription-playback/transcription-playback.component';
import { AudioTimeDirective } from './directives/audio-time.directive';
import { SavedQuotesService } from './services/savedQuote.service';
import { TranscriptService } from './services/transcript.service';
import { TranscriptChunkDownloadService } from './services/transcriptChunkDownload.service';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    MatSlideToggleModule,
    MatTooltipModule,
  ],
  providers: [
    TranscriptService,
    SavedQuotesService,
    TranscriptChunkDownloadService,
  ],
  declarations: [TranscriptionPlaybackComponent, AudioTimeDirective],
  exports: [TranscriptionPlaybackComponent],
})
export class TranscriptionModule {}
